module.exports = __webpack_public_path__ + "assets/images/liveLogging-29727d720071690475f519c0ae4e7bd9.png";